var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUserChats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-2{fill:#6c7ef2}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2119",
    "data-name": "Group 2119",
    transform: "translate(-169 -164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_4143",
    d: "M0 0H98V98H0z",
    "data-name": "Rectangle 4143",
    transform: "translate(169 164)",
    style: {
      fill: "none",
      opacity: 0
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2118",
    "data-name": "Group 2118",
    transform: "translate(-82.92 -211.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Subtraction_1",
    d: "M341.043 405.32h-30.62v6.128h30.62v40.326l-3.578-3.578h-45.417V427.3h-6.128v20.9a6.144 6.144 0 0 0 6.128 6.128h42.877l12.246 12.246v-55.126a6.13 6.13 0 0 0-6.128-6.128z",
    className: "prefix__cls-2",
    "data-name": "Subtraction 1",
    transform: "translate(2.749 2.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1400",
    d: "M307.043 380.32h-48.995a6.144 6.144 0 0 0-6.128 6.128v55.123l12.257-12.257h42.866a6.142 6.142 0 0 0 6.128-6.118v-36.748a6.144 6.144 0 0 0-6.128-6.128zm0 42.877h-45.417l-3.578 3.578v-40.327h48.995z",
    className: "prefix__cls-2",
    "data-name": "Path 1400"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserChats);
export default __webpack_public_path__ + "static/media/no_user_chats.7bed40427139576df247e2b83a8913c3.svg";
export { ForwardRef as ReactComponent };